






















































import { Component, Prop, Vue } from 'vue-property-decorator';
import PageLoader from '@components/common/PageLoader.vue';
import Toast from '@common/helpers/toast';

@Component({
  components: {
    PageLoader,
  },
})
export default class PopupConfirmCopy extends Vue {
  @Prop({ default: '' }) public title!: string;
  @Prop({ default: '' }) public description!: string;
  @Prop({ default: () => [] }) public selectedItems!: any[];

  public isLoading: boolean = false;
  public modalTitle: string = '';
  public modalDescription: string = '';
  public itemsToCopy: any[] = [];

  handleBeforeOpen(event: any) {
    const params = event.params || {};
    this.modalTitle = params.title || this.title;
    this.modalDescription = params.description || this.description;
    this.itemsToCopy = params.selectedItems || [...this.selectedItems];
  }

  confirm() {
    try {
      this.isLoading = true;
      const ids = this.itemsToCopy.map((item) => item.id);
      this.$emit('confirmCopy', ids);
      this.$modal.hide('popup-confirm-copy');
    } catch (error) {
      Toast.error('コピーが失敗しました。');
    } finally {
      this.isLoading = false;
    }
  }

  cancel() {
    this.$modal.hide('popup-confirm-copy');
  }
}
